<template>
  <div v-if="item.type == 'text'">
    <div v-if="!preview">
      <vs-dropdown vs-custom-content vs-trigger-click>
        <vs-button
          v-if="!preview"
          style="cursor: pointer;"
          radius
          color="danger"
          type="flat"
          icon-pack="feather"
          icon="icon-trash"
        ></vs-button>
        <vs-dropdown-menu class="dropdown-login">
          <div class="dropdownMenu">
            <div class="d-flex" style="justify-content:space-between">
              <h3 class="mb-3">Supprimer ?</h3>
            </div>
            <vs-button
              style="width:100% !important;"
              @click="remove()"
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-check"
              size="flat"
            ></vs-button>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
      <quill-editor
        v-model="item.title"
        :disabled="!contenteditable"
        :options="editorOption"
        v-if="!preview"
        >{{ item.title }}
      </quill-editor>
    </div>
    <div v-else  v-html="item.title">
      {{ item.title }}
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import map from "lodash/map";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor, Quill } from "vue-quill-editor";
import VideoResize from 'quill-video-resize-module2'
Quill.register('modules/VideoResize', VideoResize)

var toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  [{ list: "ordered" }, { list: "bullet" }],
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['video'],
  ["clean"], // remove formatting button
];

export default {
  props: [
    "preview",
    "contenteditable",
    "item",
    "colIndex",
    "rowIndex",
    "layout",
    "index",
  ],

  //  toolbar: toolbarOptions,
  //         videoResize: {
  //           // See optional "config" below
  //         }
  data() {
    return {
      editorOption: {
        theme: 'snow',
        placeholder: "Entrez votre texte ici...",
        modules: {
          toolbar: toolbarOptions,
          VideoResize: {
        	}
        },
      },
      content: "",
    };
  },
  methods: {
    remove() {
      this.layout[this.rowIndex].col[this.colIndex].content.splice(
        this.index,
        1
      );
    },
  },
  components: {
    quillEditor,
    VideoResize
  },
};
</script>

<style scoped>
[contenteditable]:focus {
  pointer-events: none;
  outline: 0px solid transparent;
}
</style>
<style>
.quill-editor iframe,
.quill-editor video {
    pointer-events: none;
}
iframe.ql-video{
    width: 100%;
    min-height: 480px;
    height: calc((9 / 16) * 100vw);
    max-height: calc(100vh - 169px);
}
</style>